"use client";

import { Award, Clock, ShieldCheck, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseItems = [{
  icon: Award,
  title: "Global Trade & Representation",
  description: "Strategic sole agent and manufacturer representation across the USA, Kenya, and Guinea, facilitating seamless international commerce."
}, {
  icon: Clock,
  title: "Industrial & Mining Supply",
  description: "Comprehensive procurement solutions for mining firms and government tenders, delivering critical equipment and project supplies."
}, {
  icon: ShieldCheck,
  title: "Logistics & Transport",
  description: "Specialized NEMT, NMT, and global freight services backed by a robust network of affiliated companies and dispatch support."
}, {
  icon: Zap,
  title: "Sustainable Energy Systems",
  description: "Advanced solar water pumps and integrated solar systems designed for large-scale agricultural and industrial applications."
}];
export default function FrontierExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257596" id="core-pillars-of-excellence" className="bg-background py-24 border-t border-border">
      <div className="page-container">
        <div className="text-center mb-16">
          <span className="text-primary font-semibold tracking-widest uppercase text-sm mb-4 block font-default">
            Strategic Business Platform
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-secondary font-default tracking-tight">
            Core Pillars of Excellence
          </h2>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {expertiseItems.map((item, i) => <div key={i} data-index={i} className={`flex flex-col items-center text-center transition-all duration-700 ease-out group hover:bg-muted/50 p-6 rounded-lg ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="w-16 h-16 rounded-lg border border-primary/20 bg-accent flex items-center justify-center mb-6 text-primary shrink-0 transition-colors duration-300 group-hover:border-primary/50">
                <item.icon className="w-8 h-8" strokeWidth={1} />
              </div>
              <h3 className="text-[24px] font-semibold text-secondary font-default mb-4 tracking-wider">
                {item.title}
              </h3>
              <p className="text-[18px] text-muted-foreground font-default leading-relaxed tracking-wide">
                {item.description}
              </p>
              <div className="mt-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center text-primary text-sm font-semibold tracking-widest uppercase">
                Learn More <span className="ml-2">→</span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}